import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { MdEmail, MdPhone } from 'react-icons/md'
import axiosInterceptorInstance from '../../utils/axios/axiosInterceptorInstance'
import Logo from '../../assets/images/logo/revvit-logo.png'

const MaintenancePage = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await axiosInterceptorInstance.get(
          '/maintenance/config',
        )
        setData(response.data)
      } catch (error) {
        console.error('Error fetching maintenance info:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchStatus()
  }, [])

  if (loading) {
    return (
      <div className='h-screen flex items-center justify-center bg-[#dfe3f1]'>
        <div className='w-10 h-10 border-4 border-[#4f46e5] border-t-transparent rounded-full animate-spin'></div>
      </div>
    )
  }

  return (
    /* 1. FRAME: The outer background container */
    <div className='h-screen w-full bg-[#dfe3f1] flex items-center justify-center p-6 md:p-14 overflow-hidden font-sans'>
      <div className='w-full max-w-6xl h-full bg-white rounded-lg shadow-sm flex flex-col items-center py-10 px-6 md:px-20 overflow-hidden'>
        {/* Logo Section */}
        <div className='flex items-center gap-2 mb-10 shrink-0'>
          <div className=' p-2  rounded flex items-center justify-center'>
            <span className='text-white font-bold text-[10px]'>
              <img
                src={Logo}
                alt='Logo'
                className='w-auto h-[30px] w-[35px] object-contain '
              />{' '}
            </span>
          </div>
        </div>

        {/* Text Section */}
        <div className='text-center shrink-0'>
          <h1 className='text-3xl md:text-5xl font-bold text-[#ef0252] mb-4 tracking-tight'>
            {data?.title || "We'll Be Back Soon"}
          </h1>
          <p className='text-[#6b7280] text-sm md:text-base max-w-xl mx-auto leading-relaxed mb-6'>
            {data?.description ||
              'Sleeknote is down for scheduled maintenance and expect to back online in a few minutes.'}
          </p>
        </div>

        {/* 3. IMAGE: Center content that shrinks to fit the screen */}
        <div className='flex-1 w-full flex items-center justify-center min-h-0 mb-10'>
          <img
            src={
              data?.image ||
              'https://img.freepik.com/free-vector/maintenance-concept-illustration_114360-391.jpg'
            }
            alt='Maintenance'
            className='max-w-[400px] max-h-full object-contain'
          />
        </div>

        {/* 4. ORIGINAL FOOTER: Preserving your exact layout logic */}
        <div className='w-full shrink-0 flex flex-col items-center'>
          {/* Horizontal Line Divider (from your original) */}
          {(data?.email || data?.phone) && (
            <div className='w-full flex items-center mb-6'>
              <div className='flex-grow h-px bg-slate-100'></div>
              <span className='px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest whitespace-nowrap'>
                {data?.contactUsText}
              </span>
              <div className='flex-grow h-px bg-slate-100'></div>
            </div>
          )}

          {/* Contact Information Row (from your original) */}
          <div className='flex flex-col md:flex-row items-center gap-4 md:gap-8 mb-4 text-slate-600'>
            {data?.email && (
              <div className='flex items-center gap-2 hover:text-blue-600 transition-colors cursor-pointer'>
                <MdEmail className='text-blue-500 text-lg' />
                <a
                  href={`mailto:${data.email}`}
                  className='text-sm font-semibold'
                >
                  {data.email}
                </a>
              </div>
            )}
            {data?.phone && (
              <div className='flex items-center gap-2 hover:text-blue-600 transition-colors cursor-pointer'>
                <MdPhone className='text-blue-500 text-lg' />
                <a
                  href={`tel:${data?.phone}`}
                  className='text-sm font-semibold'
                >
                  {data.phone}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MaintenancePage
